package com.cybersoftsolution.cybersoftsolutionweb.components.htmlEditor

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.PrimaryButtonStyleDisabled
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Bold_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Code_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Heading_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Image_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Italic_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Link_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Paragraph_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Quote_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Subtitle_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.TikTok_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Title_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Underline_ICO
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources.EditorIconsClassName.Youtube_ICO
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.disabled
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div


@Composable
    fun EditorKeyIcon(
    enabled: Boolean = true,
    id: String = "EditorKeyIconId",
    selected: Boolean = false,
    modifier: Modifier = Modifier,
    editorKey: EditorKey,
    onClick: () -> Unit = {},
    ) {

        var isSelected by remember { mutableStateOf(selected) }

        val style = if (enabled) PrimaryButtonStyle else PrimaryButtonStyleDisabled

    Button(
        attrs = style.toModifier()
                    .then(modifier)
                    .id(id)
                    .disabled(!enabled)
            .cursor(Cursor.Pointer)

//            .thenIf(
//                condition = isSelected,
//                other = Modifier.backgroundColor(Theme.PrimaryButton.rgb)
//            )

//                    .backgroundColor(Colors.LightGray)
//            .height(54.px)
            .height(38.px)
            .width(38.px)
            .borderRadius(4.px)
//            .fontWeight(FontWeight.Normal)
//                    .fontSize(FontSize.Medium)
//                    .thenIf(
//                        condition = enabled,
//                        other = Modifier.cursor(Cursor.Pointer)
//                    )
            .onClick {
//                isSelected = !isSelected
                onClick()
            }
            .toAttrs(),
    ){
        Div  (
            attrs = Modifier
//                .classNames("fa-solid",editorKey.icon)
                .classNames(editorKey.className,editorKey.icon)
                .toAttrs{}
        )


    }

//        Box(
//            contentAlignment = Alignment.Center,
//            modifier = modifier
//                .fillMaxHeight()
////                .margin(right = 12.px)
//                .borderRadius(4.px)
//                .cursor(Cursor.Pointer)
//                .onClick {
//                    onClick()
//                }
//        ) {
//
//
//
//        }





    }

    enum class EditorKey(
        val className: String,
        val icon: String,
    ) {
        BoldIcon( className = Bold_ICO.first, icon = Bold_ICO.second),
        ItalicIcon( className = Italic_ICO.first, icon = Italic_ICO.second),
        Title( className = Title_ICO.first, icon = Title_ICO.second),
        HeadingIcon( className = Heading_ICO.first, icon = Heading_ICO.second),
        UnderlineIcon( className = Underline_ICO.first, icon = Underline_ICO.second),
        LinkIcon( className = Link_ICO.first, icon = Link_ICO.second),
        CodeIcon( className = Code_ICO.first, icon = Code_ICO.second),
        ImageIcon( className = Image_ICO.first, icon = Image_ICO.second),
        YoutubeIcon( className = Youtube_ICO.first, icon = Youtube_ICO.second),
        TikTokIcon( className = TikTok_ICO.first, icon = TikTok_ICO.second),
        Subtitle( className = Subtitle_ICO.first, icon = Subtitle_ICO.second),
        Quote( className = Quote_ICO.first, icon = Quote_ICO.second),
        Paragraph( className = Paragraph_ICO.first, icon = Paragraph_ICO.second),

    }
